import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  Redirect,
  withRouter
} from 'react-router-dom'
import { Badge, Layout, Button, Divider, Breadcrumb, Card } from 'antd';
import Dashboard from './dashboard';
import EditableTable from './projects';
import News from './news';
import Promotions from './promotions';
import aNews from './anews';
import aPromotions from './apromotions';
import Login from './login';
import Values from './values';
import Media from './media';
import Landing from './landing';
import fakeAuth from './autha';

import ChangePW from './changepw'; 
import { auth } from '../firebase';


import "../App.css";

const ButtonGroup = Button.Group;


const Public = () => <h2>This page is public, no sign in required.</h2>

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    fakeAuth.isAuthenticated === true
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />
)

const AuthButton = withRouter(({ history }) => (
  fakeAuth.isAuthenticated ? (
    <div>
      <Card className='header'>
        <p>Welcome!</p>
        <Divider type="vertical" />
        <Button  size='large' onClick={() => {
          auth.doSignOut().then(function() {
            // Sign-out successful.
            fakeAuth.signout(() => history.push('/'))
          }).catch(function(error) {
            console.log('signout error')
          });
        }}>Sign out
      </Button>
      <Divider type="vertical" />
      <Button type='primary'  size='large' ghost><Link to='/changepw'>
            Change Password
        </Link></Button>
        <ButtonGroup size='large' className="np" >
          <Button type='primary' ><Link to='/dashboard/promotions'>
            Promotions
        </Link></Button>
          <Button type='primary' ><Link to='/dashboard/news'>
            News
        </Link></Button>
        </ButtonGroup>
      </Card>
    </div>
  ) : (
      <Card className='header'>
        <p>CCBCMS - Interactive Panel CMS</p>
      </Card>
    )
))








const breadcrumbNameMap = {
  '/admin': 'Admin',
  '/dashboard': 'Dashboard',
  '/dashboard/promotions': 'Promotions',
  '/dashboard/news': 'News',
  '/dashboard/promotions/archive': 'Archived Promotions',
  '/dashboard/news/archive': 'Archived News',
  '/dashboard/projects/:id': 'ff',
};
const Bread = withRouter((props) => {
  const { location } = props;
  const pathSnippets = location.pathname.split('/').filter(i => i);
  // var id = pathSnippets[2];
  var name = 'archive'

  // if (pathSnippets.length > 3) {
  //   pathSnippets.splice(2, 1)
  //   name = pathSnippets[2];
  // }

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;

    return (
      <Breadcrumb.Item key={url}>
        <Link to={url}>
          {breadcrumbNameMap[url]}
        </Link>
      </Breadcrumb.Item>
    );
  });

  const breadcrumbItems = [(
    <Breadcrumb.Item key="home">
      <Link to="/">Home</Link>
    </Breadcrumb.Item>
  )].concat(extraBreadcrumbItems);
  return (
    <Breadcrumb>
      {breadcrumbItems}
    </Breadcrumb>

  );
});


export default function AuthExample() {
  return (
    <Router>
      <div>
        <Layout className="App">
          <div className="block">
            <AuthButton className="nq" />
          </div>
          <Card className='header'>
            <Bread />
          </Card>

          <Switch>
            <Route path="/public" component={Public} />
            <PrivateRoute exact path="/" component={Dashboard} />
            <Route path="/login" component={Login} />
            <PrivateRoute exact path='/dashboard' component={Dashboard} />
            <PrivateRoute exact path='/changepw' component={ChangePW} />

            {/* <PrivateRoute exact path='/admin' component={Landing} /> */}
            <PrivateRoute exact path='/dashboard/promotions' component={Promotions} />
            <PrivateRoute exact path='/dashboard/news' component={News} />

            <PrivateRoute exact path='/dashboard/promotions/archive' component={aPromotions} />
            <PrivateRoute exact path='/dashboard/news/archive' component={aNews} />

            <PrivateRoute exact path='/dashboard/values' component={News} />
            <PrivateRoute path='/dashboard/values/:id/:name' component={Values} />
            <PrivateRoute path='/dashboard/projects/:id/:name' component={EditableTable} />


            <PrivateRoute path='/dashboard/events/:id/:title' component={Media} />


            <Route component={Login} />
          </Switch>


        </Layout>
      </div>
    </Router>
  )
}


// WEBPACK FOOTER //
// ./src/views/home.js